
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/website-development",
      function () {
        return require("private-next-pages/services/website-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/website-development"])
      });
    }
  